import React from 'react';
import BaseField from '../base-field/BaseField.component';
import ValidationError from '../validation-error/ValidationError.component';

export default function ValidField(props) {
  const {isError, errorText} = props;

  return (
    <BaseField
      {...props}
      footerChildren={
        isError && errorText && <ValidationError errorText={errorText} />
      }
    />
  );
}
